<template>
    <div class="unselectable">
    <b-navbar toggleable="lg" type="dark" variant="primary" fixed = "top"  :style="{backgroundColor: addinBgColor}">
      <i class="fas fa-circle-notch fa-spin text-white"
                             v-if="ceoWorking>0"></i>
                          <i class="fas fa-check fade-out  text-white"
                             v-if="ceoWorking+cooWorking===0"></i>
                          <span v-if="ceoWorking>0">
                      {{progress}}
                      </span>
      <ul class="list-group list-group-horizontal w-100">
        <li class="col-7 list-group-item p-0 bg-transparent border-0">
            <b-img :src="logoPath" fluid alt="gender app logo" width="150%" @click="openWebsite"
            class="unselectable center"
            style="padding-left: 15px; max-height: 30px"></b-img>
        </li>
        <li class="col-2 list-group-item p-0 bg-transparent border-0">
            <b-img :src="cobrandingLogoPath" fluid alt="cobranding logo" width="42%" v-if="cobrandingLogoPath && cobrandingLogoPath !=='null'"
            class="unselectable center"
            style="max-height: 30px"></b-img>
        </li>
        <li class="col-3 list-group-item p-0 bg-transparent border-0">
          <b-navbar-toggle target="nav-collapse" class="float-right border"></b-navbar-toggle>
        </li>
      </ul>
      <b-collapse id="nav-collapse" is-nav>
       <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">

            <b-card class="p-2" v-if="isLoggedIn()">
                <b-card-header>{{ $t('Placeholder') }}</b-card-header>
              <table class="table small table-sm">
              <tbody>
                <tr>
                  <td class="pl-4">
                    <input @input="$emit('set-star')" class="form-check-input" type="radio" name="shortformPlaceholder" id="star" value="star" v-model="shortformPlaceholder">
                    <label class="form-check-label" for="star">
                      Gendersternchen <div class="small text-muted">(Student*in)</div>
                    </label>
                  </td>
                </tr>
                <tr>
                  <td class="pl-4">
                    <input @input="$emit('set-colon')" class="form-check-input" type="radio" name="shortformPlaceholder" id="colon" value="colon" v-model="shortformPlaceholder">
                    <label class="form-check-label" for="colon">
                      Gender-Doppelpunkt <div class="small text-muted">(Student:in)</div>
                    </label>
                  </td>
                </tr>
                <tr>
                  <td class="pl-4">
                    <input @input="$emit('set-lowdash')" class="form-check-input" type="radio" name="shortformPlaceholder" id="lowdash" value="lowdash" v-model="shortformPlaceholder">
                    <label class="form-check-label" for="lowdash">
                      Gender-Gap <div class="small text-muted">(Student_in)</div>
                    </label>
                  </td>
                </tr>
                <tr>
                  <td class="pl-4">
                    <input @input="$emit('set-slash')" class="form-check-input" type="radio" name="shortformPlaceholder" id="slash" value="slash" v-model="shortformPlaceholder">
                    <label class="form-check-label" for="slash">
                      Kurzform <div class="small text-muted">(Student/-in)</div>
                    </label>
                  </td>
                </tr>
              </tbody>
            </table>

              <div v-if="isAnonymous()">
                <b-alert show dismissible variant="info" class="small">
                  {{$t('login to save your preferences')}}
                </b-alert>
              </div>
            </b-card>

<!--            <b-card class="p-2" v-if="isLoggedIn()">-->
<!--                <b-card-header>{{$t('options')}}</b-card-header>-->
<!--                <b-form-checkbox @input="$emit('toggle-star')" class="pt-2" v-model="starForm">{{$t('Show star form')}}</b-form-checkbox>-->
<!--                <b-form-checkbox @input="$emit('toggle-pair')" class="pt-2" v-model="pairForm">{{$t('Show pair form')}}</b-form-checkbox>-->
<!--                <b-form-checkbox @input="$emit('toggle-singular')" class="pt-2" v-model="singularForm">{{$t('Show singular form')}}</b-form-checkbox>-->
<!--            </b-card>-->

            <b-nav-item :to="{name:'auth.login'}" v-if="!isLoggedIn()">{{$t('Login')}}</b-nav-item>
            <b-nav-item @click='openRegister' v-if="!isLoggedIn()">{{$t('Register')}}</b-nav-item>
            <b-nav-item href="#" @click="makeLogout" v-if="isLoggedIn() && !isAnonymousUser()">{{$t("Sign Out")}} </b-nav-item>
            <b-nav-item href="#" @click="makeLogout" v-if="isLoggedIn() && isAnonymousUser()">{{$t("Login")}} </b-nav-item>
            </b-navbar-nav>
      </b-collapse>
    </b-navbar>

      <div>
      <b-modal hide-footer ref="registerModal" v-bind:title="$t('you are not logged in')">
        <div class="d-block text-center">
          <h3>{{$t('wanna create an account?')}}</h3>
        </div>
        <router-link :to="{name: 'auth.register'}" class="mt-2 btn btn-outline-success btn-block">{{$t("Go to register")}}</router-link>
        <b-button block @click="hideRegistrationModal" class="mt-2 btn btn-outline-danger btn-block">{{$t("Cancel")}}</b-button>
      </b-modal>
    </div>
    </div>
</template>

<script>
import { AuthService } from '../services/auth.service'
import { HOMEPAGE_URL } from '../env'
import { ProfileService } from '@/services/profile.service'

var Vue = require('vue')
export default {
  name: 'TopNavBar',
  data () {
    return {
      starForm: true,
      pairForm: true,
      singularForm: true,
      shortformPlaceholder: '',
      logoPath: '/img/logo.png',
      cobrandingLogoPath: null,
      addinBgColor: null
    }
  },
  watch: {
    shortformPlaceholder: function () {
      this.updatePlaceholder()
    }
  },
  props: ['ceoWorking', 'cooWorking'],
  created () {
    this.cobrandingLogoPath = localStorage.getItem('cobranding_logo_path')
    this.addinBgColor = localStorage.getItem('addin_bg_color')
    if (this.addinBgColor) this.addinBgColor = this.addinBgColor + ' !important'
  },
  mounted () {
    this.getShortformPlaceholder()
  },
  methods: {
    async getShortformPlaceholder () {
      if (!this.getUsername()) return
      await ProfileService.getProfileDictionaryEntryStatistics(this.getUsername())
        .then((response) => {
          this.shortformPlaceholder = response.data.shortform_placeholder
        }).catch((error) => {
          console.log(error)
        })
    },
    updatePlaceholder () {
      ProfileService.updatePlaceholder(this.getUsername(), this.shortformPlaceholder)
        .catch((error) => {
          console.log(error)
        })
    },
    openRegister () {
      window.open(HOMEPAGE_URL + '/register', '_blank')
    },
    openWebsite () {
      window.open(HOMEPAGE_URL + '/', '_blank')
    },
    makeLogout () {
      AuthService.makeLogout()
      window.location.reload()
    },
    isAnonymous () {
      return this.getUsername() === 'anonymous'
    },
    getUsername () {
      let username = Vue.default.cookie.get('username')
      if (!username) username = localStorage.getItem('genderAppUsername')
      // if (username === 'anonymous') return undefined
      return username
    },
    isLoggedIn () {
      const token = Vue.default.cookie.get('token')
      if (!token) {
        const localStorageToken = localStorage.getItem('genderAppToken')
        return !!localStorageToken
      }
      return !!token
    },
    isAnonymousUser () {
      const localStorageUsername = localStorage.getItem('genderAppUsername')
      return localStorageUsername === 'anonymous'
    },
    showRegistrationModal () {
      this.$refs.registerModal.show()
    },
    hideRegistrationModal () {
      this.$refs.registerModal.hide()
    }
  }
}
</script>

<style scoped>

    .card {
        margin: 10px;
    }
    .card-body {
        border: 5px;
        padding: 10px;
        border: transparent;
    }
    .card-header {
        border: 5px;
        padding: 4px;
        border: transparent;
    }
    .center {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
<style>
.navbar-nav {
    overflow: auto;
    height: 80vh;
}
/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
